import {
  AfterViewInit,
  Component,
  OnInit,
  ViewChild,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core'
import { ToggleMfaBody, User } from '../../../../types/users'
import { MatTableDataSource, MatTableModule } from '@angular/material/table'
import {
  MatPaginator,
  MatPaginatorIntl,
  MatPaginatorModule,
} from '@angular/material/paginator'
import { Dialog } from '@angular/cdk/dialog'
import { UserService } from '../../../../services/user.service'
import { ApiError } from '../../../../types/apiError'
import { firstValueFrom } from 'rxjs'
import { DialogService } from '../../../../services/dialog.service'
import { ErrorService } from '../../../../services/error.service'
import { SpinnerService } from '../../../../services/spinner.service'
import { WindowService } from '../../../../services/window.service'
import { PaginatorIntl } from '../../../intl/paginator-intl'
import { TranslationService } from '../../../../services/translation.service'
import { CommonModule } from '@angular/common'
import { AuthService } from '../../../../services/auth.service'
import { RouterModule } from '@angular/router'
@Component({
  selector: 'app-user-list',
  imports: [MatTableModule, MatPaginatorModule, CommonModule, RouterModule],
  providers: [
    {
      provide: MatPaginatorIntl,
      useClass: PaginatorIntl,
    },
  ],
  templateUrl: './user-list.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './user-list.component.scss',
})
export class UserListComponent implements OnInit, AfterViewInit {
  dialog = inject(Dialog)
  dialogService = inject(DialogService)
  userService = inject(UserService)
  spinnerService = inject(SpinnerService)
  errorService = inject(ErrorService)
  windowService = inject(WindowService)
  translationService = inject(TranslationService)
  authService = inject(AuthService)

  @ViewChild(MatPaginator) paginator!: MatPaginator
  users: Array<User> = []

  displayedColumns: string[] = ['email', 'role', 'company', 'mfaEnabled']
  dataSource = new MatTableDataSource<User>([])

  isMobileView: boolean = false

  async ngOnInit(): Promise<void> {
    try {
      this.windowService.isMobileView$.subscribe((isMobileView) => {
        this.isMobileView = isMobileView
      })
      this.spinnerService.startSpinner()
      const usersResponse = await firstValueFrom(this.userService.getAll())
      this.users = usersResponse
      this.dataSource.data = this.users
      this.spinnerService.stopSpinner()
    } catch (err) {
      this.spinnerService.stopSpinner()
      const apiErr = err as ApiError
      this.errorService.handleErr(this.dialogService, apiErr, this.dialog)
    }
  }

  ngAfterViewInit(): void {
    // Assigns the paginator to table dataSource
    this.dataSource.paginator = this.paginator
  }

  /**
   * Toggles a user's mfa enabled status.
   * @param {User} user The user
   */
  async toggleMfa(user: User) {
    try {
      this.spinnerService.startSpinner()
      if (!user.id) {
        return
      }

      const newMfaState = !user.mfaEnabled
      const toggleRequest: ToggleMfaBody = {
        userId: user.id,
        enabled: newMfaState,
      }

      await firstValueFrom(this.authService.toggleMfa(toggleRequest))

      user.mfaEnabled = newMfaState

      this.spinnerService.stopSpinner()
    } catch (err) {
      this.spinnerService.stopSpinner()
      const apiErr = err as ApiError
      this.errorService.handleErr(this.dialogService, apiErr, this.dialog)
    }
    if (!user.id) {
      return
    }
  }
}
